<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Reprocessamento de Aquisição e Reativação"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getAcquisitionAndReactivationReprocess"
  emptyMessage="Sem mais pagamentos para reprocessar."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="Registros"
  [defaultRows]="15"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
